<template>
  <div>
    <el-button class="mt-10 mb-10" :disabled="list.length >= metricOption.length" @click="add()">添加</el-button>
    <el-table
        :data="list"
    >
      <el-table-column label="选择指标">
        <template v-slot="{ row, $index }">
          <el-select v-model="row.metric" clearable size="small">
            <el-option :disabled="list.some(el=>el.metric === item.code)" v-for="(item, index) in metricOption"
                       :key="index"
                       :label="item.name" :value="item.code"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="线条类型" min-width="90px" v-if="props.additionConfig.includes('smooth')">
        <template v-slot="{ row, $index }">
          <el-select v-model="row.smooth" size="small">
            <el-option v-for="(item, index) in smoothType" :key="index" :label="item.label" :value="item.value"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="线条宽度" min-width="90px">
        <template v-slot="{ row, $index }">
          <el-input-number style="width: 80px" size="small" controls-position="right"
                           v-model="row.lineWidth"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="显示标记点">
        <template v-slot="{ row, $index }">
          <el-switch v-model="row.showSymbol"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="标记点形状">
        <template v-slot="{ row, $index }">
          <el-select v-model="row.symbolKind" size="small">
            <el-option v-for="(item, index) in symbolKind" :key="index" :label="item.label" :value="item.value"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="标记点直径" min-width="90px">
        <template v-slot="{ row, $index }">
          <el-input-number style="width: 80px" size="small" controls-position="right"
                           v-model="row.symbolSize"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="显示面积">
        <template v-slot="{ row, $index }">
          <el-switch v-model="row.showArea"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="面积透明度">
        <template v-slot="{ row, $index }">
          <el-slider v-model="row.areaOpacity" :max="1" :step="0.1"></el-slider>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{ row, $index }">
          <el-link type="primary" @click="list.splice($index,1)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script setup>
import {ref} from "vue";
import {cloneDeep} from "lodash-es";

const props = defineProps({
  main: {},
  additionConfig: { // 附加属性配置
    type: Array,
    default: () => []
  }
})
const list = ref([])
if (props.main.activeOption.lineCustomSet) {
  list.value = cloneDeep(props.main.activeOption.lineCustomSet)
}
const metricOption = computed(() => {
  return metricsMerge(props.main.activeObj.prop)
  // return props.main.activeObj.prop.metrics || [];
})

// 指标 metrics、metricsL、metricsR 组合
// 主指标code直接匹配  非主指标 匹配模式为 类型--指标编码；例如: metricsL: metricsL--xxxxcode
function metricsMerge (config) {
  const arrList = []
  if(!config) return list

  const BuiltInFunctions = (type, item) => {
    if(item?.[type] && item[type].length) {
      arrList.push(...item[type].map(v=>({
        ...v,
        code: type==='metrics' ? v.code : `${type}--${v.code}`
      })))
    }
  }
  BuiltInFunctions('metrics', config)
  BuiltInFunctions('metricsL', config)
  BuiltInFunctions('metricsR', config)
  return arrList
}

const symbolKind = [
  {label: "默认", value: "emptyCircle"},
  {label: "圆形", value: "circle"},
  {
    label: "正方形",
    value: "rect"
  },
  {label: "三角形", value: "triangle"},
  {label: "菱形", value: "diamond"},
  {label: "别针", value: "pin"}]

// 线条类型
const smoothType = [
  { label: '直线', value: false },
  { label: '曲线', value: true },
]

function add() {
  list.value.push({})
}

defineExpose({
  getSetting() {
    return list.value
  }
})
</script>
<style lang="scss">

</style>